import {createPoint} from '@gaia/utils/gaia/createTrackPoint';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {boldTrackColors} from '@gaia/utils/gaia/trackColors';
import keyBy from 'lodash/keyBy';
import sample from 'lodash/sample';
import uniqueId from 'lodash/uniqueId';

export function createTrack(track?: PartialTrack | PartialPointTrack): Track {
    const localId = uniqueId('track');

    const newPoints = () => {
        if (!track || !('points' in track) || !track.points) {
            return {};
        }
        const pointObj: {[id: string]: TrackPoint} = {};
        for (const key in track?.points) {
            if (track.points[key].properties.archived || track.points[key].properties.deleted) {
                continue;
            }
            const newPoint = createPoint(
                track.points[key].geometry.coordinates,
                track.points[key].properties.order,
                localId
            );
            pointObj[newPoint.properties.localId] = newPoint;
        }
        return pointObj;
    };

    const unmodifiedLine = (): TrackLine | undefined => {
        if (!track || !('geometry' in track) || !track.geometry) {
            return undefined;
        }

        return {
            type: 'Feature',
            geometry: track.geometry,
            properties: {
                isGeometryLoaded: true,
                localId,
                lineLocalId: localId,
                fromPointLocalId: undefined,
                toPointLocalId: undefined,
                type: 'normal',
            },
        };
    };

    return {
        properties: {
            color: sample(boldTrackColors),
            title: 'Untitled Route',
            time_created: new Date().toISOString(),
            routing_mode: 'pedestrian',
            track_type: 'route',
            ...track?.properties,
            localId,
            writable: true,
            archived: false,
            isPublicTrack: false,
            isLocallyCreated: true,
            type: 'track',
        },
        isGeometryLoaded: true,
        points: newPoints(),
        unmodifiedLine: unmodifiedLine(),
    };
}
export default function create(
    action: CreateTrackAction,
    setTracks: React.Dispatch<React.SetStateAction<{[localId: string]: Track}>>
) {
    ampli.duplicateObject({type: 'route', category: 'map2'});
    const data = !action.data
        ? [createTrack()]
        : (Array.isArray(action.data) ? action.data : [action.data]).map((feature) =>
              createTrack(feature)
          );

    setTracks((latestTracks) => ({
        ...latestTracks,
        ...keyBy(data, (track) => track.properties.localId),
    }));

    if (action.callback) {
        action.callback(data[0]);
    }

    return data.map((track) => track.properties.localId);
}
